import React from "react";
import PropTypes from "prop-types";
import ImageZoom from "react-medium-image-zoom";

const ImageZoomer = ({src,alt,imgStyle,containerStyles}) => {

	return <ImageZoom
        image={{
          src: src,
          alt: alt,
          style: imgStyle,
        }}
        zoomImage={{
          src: src,
          alt: `zoom-${alt}`,
        }}
        defaultStyles={containerStyles}
    />
}

ImageZoomer.defaultProps = {
	imgStyle: {},
	alt: "preview",
	containerStyles: { overlay: { backgroundColor: '#000000b6' } }
};

ImageZoomer.propTypes = {
	imgStyle: PropTypes.object,
	alt: PropTypes.string,
	src: PropTypes.string
}

export default ImageZoomer;


// WEBPACK FOOTER //
// ./src/components/ImageZoomer.js